import css from 'styled-jsx/css';
import { colors, icons } from '../../../config/styles';
import { svgToDataUri } from '../../../utils/styles/svgMixins';

export const WarrantyStyles = css`
  /* Block: Main warranty component */
  .warranty {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 24px;
  }

  /* Elements: Component parts */
  .warranty__header {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
  }

  .warranty__icon {
    display: flex;
    width: 20px;
    height: 20px;
    background-image: url('${icons.warrantyIcon ? svgToDataUri(icons.warrantyIcon) : ''}');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    flex-shrink: 0;
  }

  .warranty__title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    color: ${colors.black.shade1};
  }

  .warranty__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border: 1px solid ${colors.gray.shade2};
    border-radius: 12px;
    gap: 16px;
    min-height: 60px;
  }

  .warranty__option {
    display: flex;
    gap: 12px;
    align-items: center;
    flex: 1;
  }

  .warranty__label {
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: ${colors.black.shade1};
    flex: 1;
  }

  .warranty__price {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    flex-shrink: 0;
    gap: 2px;
  }

  .warranty__price-text {
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    color: ${colors.black.shade1};
  }

  .warranty__more-options {
    font-size: 14px;
    font-weight: 700;
    color: ${colors.primary};
    line-height: 18px;
    border: none;
    background: none;
    cursor: pointer;
    padding: 8px 0;
    text-decoration: underline;
    transition: all 0.2s ease;
    text-align: left;
  }

  .warranty__more-options:hover {
    color: ${colors.primary};
    text-decoration: none;
  }

  .warranty__more-options:focus {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  /* Legacy modifier for fallback UI */
  .warranty--legacy {
    /* Inherits styles from SingleChipletSelect */
  }

  /* Modal styles (inherited from original) */
  .warranty-pop-up {
    position: fixed;
    inset: 0;
    display: flex;
    flex-direction: column;
    cursor: initial;
    height: 100%;
    width: 100%;
    z-index: 200;
    background-color: ${colors.black.shade13};
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    position: relative;
    width: 680px;
    padding: 24px;
    height: fit-content;
    border-radius: 12px;
    overflow: auto;
    background-color: ${colors.white.shade1};
  }

  .drawer-content {
    padding: 8px 20px 20px 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;
